import {
    INIT_MY_PAGE,
} from './types';

export const initMyPage = config => ({
    type: INIT_MY_PAGE,
    payload: config,
});
